const props = { MuiButton: { disableRipple: true } }

export default props
